import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import classnames from 'classnames';
import SubMenu from './Submenu';

const MenuItem = ({ parent, link, level, path }) => {

  const [isActive, setIsActive] = useState(false);

  const optionClasses = classnames('Nav__item', `level-${level}`, {
    'is-active': link.active | isActive,
    'has-submenu': link.children.length > 0
  });

  const handleClick = (e) => {
    if (link.children.length > 0) {
      if (!isActive) {
        e.preventDefault();
        setIsActive(!isActive);
      }
    }
  };

  return (
    <div className={optionClasses}>
      <a onClick={handleClick} href={link.url} className={`Nav__link level-${level}`} target={!!link.target ? link.target : null}>
        <span>
          {link.name}
          {link.children.length > 0 && " +"}
        </span>
      </a>
      {link.children.length > 0 &&
        <AnimatePresence>
          {isActive && (
            <SubMenu items={link.children} parent={link} level={level} path={path} open={isActive}></SubMenu>
          )}
        </AnimatePresence>
      }
    </div>
  );
};

export default MenuItem